import React from "react";
import Typography from "@material-ui/core/Typography";
import AppColors from './../colors/AppColors'
import { Divider } from "@material-ui/core";
import { blueGrey } from "@material-ui/core/colors";

const FeatureCardItem = (props: any) => (
    <div
        style={{
            margin: 'auto',
            height: 300,
            width: 300,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 20
        }}>
        <div><img
            style={{
                marginTop: props.title.toLowerCase().includes("invest") ? 20 : 0
            }}
            src={props.imageSrc} width={props.title.toLowerCase().includes("invest") ? 100 : 60} height={props.title.toLowerCase().includes("invest") ? 50 : 60} /></div>
        <Divider color={AppColors.EASE_GRAY} />
        <Typography
            style={{
                marginTop: 10,
                marginBottom: 20,
                fontSize: 28,
                fontWeight: 600,
            }}
            dangerouslySetInnerHTML={{ __html: props.title }} />
        <Typography
            style={{
                fontSize: 18,
                color: blueGrey[900],
                textAlign: 'center'
            }}
            dangerouslySetInnerHTML={{ __html: props.description }} />
    </div>
);

export default FeatureCardItem;
